export default __webpack_public_path__ + "static/media/Taurus.78e11853.svg";